export default __webpack_public_path__ + "static/media/emptyPromo.4b7ce252.png";